import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=8e23b4d4"
import script from "./edit.js?vue&type=script&lang=js&external"
export * from "./edit.js?vue&type=script&lang=js&external"
import style0 from "./edit.vue?vue&type=style&index=0&id=8e23b4d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports